import styled from 'styled-components';

export const H4 = styled.h4`
    font-size: 20px;
    color: ${p => p.theme.c.active};
    text-align: center;
    font-weight: 600;
    margin-bottom: 16px;
`;

export const P = styled.p`
    font-size: 16px;
    color: ${p => p.theme.c.grey5};
    text-align: center;
`;

export const Modified = styled(P)`
    margin-bottom: -4px;
    font-size: 15px;
    color: ${p => p.theme.c.grey7};
`;